import Component from "@base/js/component";

export default class InlineSearch extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".inline-search";

  // Defines children that needs to be queried as part of this component
  static children = {
    form: ".inline-search__form",
    input: ".inline-search__input",
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    input: {
      input: this.onInputChanged,
    },
  };

  onInputChanged(e) {
    e.preventDefault();
    if (this.children.input.value.length === 0) {
      const isFireFox = Boolean(navigator.userAgent.match(/Firefox/i));
      const submit = new Event("submit", { cancelable: isFireFox });
      this.children.form.dispatchEvent(submit);
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
InlineSearch.init();
